import routes from '@routes/config';

export default [{
    path: routes.item.index,
    name: routes.item.index,
    component: () => import(/* webpackChunkName: "Item" */  '@components/Item/Index')
}]
            